import { initializeApp, getApps } from "firebase/app";
import { getStorage } from "firebase/storage";

// 🔹 Define your Storage Firebase config properly
const storageConfig = {
    apiKey: "AIzaSyAa4j3wZdw8d-PqmCD_BfuQ7f9Nm75zrL4",
    authDomain: "tgh-admin-897f1.firebaseapp.com",
    projectId: "tgh-admin-897f1",
    storageBucket: "tgh-admin-897f1.firebasestorage.app",
    messagingSenderId: "188948859607",
    appId: "1:188948859607:web:66e85be9cde0f78f6cfe92"
  };

// 🔹 Initialize only if not already initialized
const storageApp = getApps().find(app => app.name === 'storageApp') 
  || initializeApp(storageConfig, 'storageApp');

// 🔹 Get the storage instance
const storage = getStorage(storageApp);

export { storage };
